export default __webpack_public_path__ + "static/media/image4.a1deacc4.png";